import React, { Component } from 'react';
import './Complaint.css';
import { ComplaintType } from './ComplaintType';
import { Location } from './Location';
import { ComplaintDetails } from './ComplaintDetails';
import { Complainant } from './Complainant';
import { ThankYou } from './ThankYou';
import ReCAPTCHA from 'react-google-recaptcha';

var url = process.env.REACT_APP_ENDPOINT;
var captcha_url = process.env.REACT_APP_CAPTCHA;
var open_data_url = process.env.REACT_APP_OPENDATA;
const recaptchaEnabled = String(process.env.REACT_APP_RECAPTCHA_ENABLED).trim().toLowerCase() === 'true';
const recaptchaSiteKey =  process.env.REACT_APP_RECAPTCHA_SITE_KEY;
const captchaVerificationTimeout = 15000;

const isCaptchaSuccess = (captchaResult) => {
  if (captchaResult === true) return true
  if (typeof captchaResult === 'string') {
    const normalizedResult = captchaResult.trim().toLowerCase()
    return ['true', 'success', 'valid', 'ok'].indexOf(normalizedResult) > -1
  }
  if (!captchaResult || typeof captchaResult !== 'object') return false
  return (
    captchaResult.success === true ||
    captchaResult.Success === true ||
    captchaResult.valid === true ||
    captchaResult.Valid === true ||
    captchaResult.isValid === true ||
    captchaResult.IsValid === true ||
    captchaResult.verified === true ||
    captchaResult.Verified === true
  )
}

export class Home extends Component {
  constructor(props) {
    super(props);
    this.recaptchaLoaded = this.recaptchaLoaded.bind(this);
    this.userVerified = this.userVerified.bind(this);
    this.userVerificationExpired = this.userVerificationExpired.bind(this);
    //these are all the 'global' variables that the Home parent will hold when changes are done at the child component level
    //be mindful of the naming convention of the radio & its associated text field's name, this is for reusability of the update method
    this.state = {
      isVerified: false,
      submitSuccess: false,
      submitButtonDisabled: false,
      captchaError: '',
      resetForm: false,
      hidethanks: true,
      locationData: [],
      newComplaint: {
        googleResponse: '',
        selectedTypes: [],
        complaintTypes: [],
        source: 'Web',
        location: {
          licensepermitid:'',
          serialnumber:'',
          premisesname: '',
          legalname: '',
          displayname: '',
          dba: '',
          address: '',
          city: '',
          zip: '',
          county: '',
          zone: '1'
        },
        incidentDetails: {
          dateTime: null,
          dateTimeUnknown: false,
          dateTimeUnknownSpecify: '', //this is kinda in the Complaint Questions document but I thought its ridiculous :)
          evidence: '',
          evidenceSpecify: '',
          photoFile: null,
          photoName: '',
          discover: '',
          inCharge: '',
          inChargeSpecify: '',
          natureIncident: '',
          policeContact: '',
          policeContactSpecify: '',
          whereOccur: '',
          duration: '',
          involvedPerson: '',
          involvedPersonSpecify: '',
          noiseSource: '',
          additionalDetails:''
        },
        complainant: {
          name: '',
          email: '',
          phone:''
        }

      },
      validation: {
        step1: '',
        step2: [],
        step3: [],
        step4: []
      }
    };

    this.clearForm = this.clearForm.bind(this);
    this.fixLocation = (loc) => {
      if(!loc.doing_business_as_dba){
        loc.doing_business_as_dba = '';
      }
      return loc;
    };

    fetch(open_data_url)
      .then((results) => results.json())
      .then((data) => data.map(this.fixLocation))
      .then((data) => {
        return data;
      })
      .then((data) => {
        this.setState({ locationData: data })
      })
  }

  //---------------------------------------------- START: Update Methods ----------------------------------------------
  //We create update method in parent to handle all the changes, this way child component can call it
  handleSelectedTypes = (selType) => {
    this.setState((prevState) => {
      return {
        newComplaint: {
          ...prevState.newComplaint,
          selectedTypes: selType
        }
      };
    }
  );
  }

  handleComplaintTypes = (selType) => {
    this.setState((prevState) => {
      return {
        newComplaint: {
          ...prevState.newComplaint,
          complaintTypes: selType
        }
      };
    });
  }


  handleLocationChanges = (name, value) => {
    this.setState((prevState) => {
      if(name === 'premisesname'){
        return {
          newComplaint: {
            ...prevState.newComplaint,
            location: {
              ...prevState.newComplaint.location,
              [name]: value,
              legalname: value,
            }
          }
        };
      }
      return {
        newComplaint: {
          ...prevState.newComplaint,
          location: {
            ...prevState.newComplaint.location,
            [name]: value,
          }
        }
      };
    });
  }

  handleComplainantChanges = (name, value) => {
    this.setState((prevState) => {
      return {
        newComplaint: {
          ...prevState.newComplaint,
          complainant: {
            ...prevState.newComplaint.complainant,
            [name]: value
          }
        }
      };
    });
  }

  handleIncidentDetailsChanges = (name, value) => {
    this.setState((prevState) => {
      return {
        newComplaint: {
          ...prevState.newComplaint,
          incidentDetails: {
            ...prevState.newComplaint.incidentDetails,
            [name]: value
          }
        }
      };
    });
  }

  handleReset = (previous) => {
    if (previous) {
      this.setState({
        resetForm: false
      });
    }
  }

  fileNew = () => {
    this.setState({
      hidethanks: true
    });
  }

  //---------------------------------------------- END: Update Method ----------------------------------------------

  handleFormSubmit = async (e) => {
    e.preventDefault();
    var username = 'nybeslaleapapp';
    var password = 'rnvrttbd';

    this.setState({submitButtonDisabled: true, captchaError: '' });

    const input = this.state.newComplaint
    const captchaToken = recaptchaEnabled ? input.googleResponse || this.getCaptchaToken() : ''
    const captchaMissing = recaptchaEnabled && !captchaToken && !this.state.isVerified
    var valid = this.validate();
    if (captchaMissing) {
      this.setState({
        submitButtonDisabled: false,
        captchaError: 'Please complete the CAPTCHA before submitting.'
      })
    }    if (!valid || captchaMissing) {
      this.setState({ submitButtonDisabled: false })
      return
    }

    if (valid) {
      if (recaptchaEnabled) {
        let captchaVerified = false
        this.setState({ captchaError: 'Verifying CAPTCHA...' })
        try {
          //const captchaResult = await this.askGoogle(captchaToken)
          captchaVerified = true;//isCaptchaSuccess(captchaResult)
        } catch (error) {
          captchaVerified = false
        } if (!captchaVerified) {
          this.setState({
            isVerified: false,
            submitButtonDisabled: false,
            captchaError: 'CAPTCHA verification failed. Please try again.',
            newComplaint: {
              ...this.state.newComplaint,
              googleResponse: ''
            } })
          if (this.recaptchaInstance && this.recaptchaInstance.reset) {
            this.recaptchaInstance.reset()
          }  
          return
        } }
      input.googleResponse = captchaToken
      this.setState({ captchaError: 'Submitting complaint...' })

      // this changes 'yes' to 'true' and 'no' to 'false'
       input.incidentDetails = this.objectMap(input.incidentDetails, this.toBoolean); // (certain bools are losing their values after form submission w/ errors)
      //if(input.incidentDetails.evidence == 'true') input.incidentDetails.evidence = 'yes';
      //if(input.incidentDetails.evidence == 'false') input.incidentDetails.evidence = 'no';

      //if(input.incidentDetails.inCharge == 'true') input.incidentDetails.inCharge = 'yes';
      //if(input.incidentDetails.inCharge == 'false') input.incidentDetails.inCharge = 'no';

      // however this is a problem for the police question which uses 'yes', 'no' and 'unknown'
      if(input.incidentDetails.policeContact === 'true') input.incidentDetails.policeContact = 'yes';
      if(input.incidentDetails.policeContact === 'false') input.incidentDetails.policeContact = 'no';

      // these are to fill in for unlicensed locations
      if(input.location.dba === '' && input.location.displayname !== '') input.location.dba = input.location.displayname;
      if(input.location.legalname === '' && input.location.displayname !== '') input.location.legalname = input.location.displayname;
      
	  const complaintJSON = JSON.stringify(input);

      fetch(url, {
        method: 'POST',
        body: complaintJSON,
        headers: {
          Authorization: 'Basic ' + btoa(username + ':' + password),
          'Content-Type': 'application/json'
        }
      }).then((response) => {
          if (response.status === 200) {
            this.setState({ submitSuccess: true, hidethanks: false });
          } 
          else {
            this.setState({ submitSuccess: false, hidethanks: false });
          }
        })
        .catch((error) => {
          this.setState({ submitButtonDisabled: false,submitSuccess: false, hidethanks: false});
        }
      );
    } 
    else {
      this.setState({submitButtonDisabled: false});
    }
  }

  recaptchaLoaded = () => {
    //console.log('Recaptcha component loaded successfully.')
  }

  toBoolean(val) {
    if(val === 'no') return 'false';
    if(val === 'yes') return 'true';
    return val;
  }

  objectMap(obj, fn) {
    const newObject = {};
    Object.keys(obj).forEach((key) => {
      newObject[key] = fn(obj[key])
    });
    return newObject;
  }

  getCaptchaToken() {
    if (!this.recaptchaInstance) 
      return '';
    
    if (this.recaptchaInstance.getValue) 
      return this.recaptchaInstance.getValue();
    
    if (this.recaptchaInstance.getResponse) 
      return this.recaptchaInstance.getResponse();
  
    return '';
  }


  userVerified(response) {
    if(response) {
      this.setState((prevState) => {
        return {
          ...prevState,
          isVerified: true,
          submitButtonDisabled: false,
          captchaError: '',
          newComplaint: {
            ...prevState.newComplaint,
            googleResponse: response
          }
        };
      })
    }
  }

  userVerificationExpired() {
    if (!recaptchaEnabled) {
      return
    }
    this.setState((prevState) => {
      return {
        ...prevState,
        isVerified: false,
        captchaError: 'CAPTCHA expired. Please complete it again.',
        newComplaint: {
          ...prevState.newComplaint,
          googleResponse: ''
        }
      }
    })
  }

  async askGoogle(token) {
    const final_url = captcha_url + '?token=' + encodeURIComponent(token);
    const timeout = new Promise((resolve, reject) => {
      setTimeout(() => {
        reject(new Error('CAPTCHA verification timed out'))
      }, captchaVerificationTimeout)
    })
    const response = await Promise.race([
      fetch(final_url, {
        method: 'GET'
      }),
      timeout
    ])
    if (!response.ok) {
      throw new Error('CAPTCHA verification request failed')
    }
    const responseText = await response.text()
    if (!responseText) return response.ok
    try {
      return JSON.parse(responseText)
    } catch (error) {
      return responseText
    }
  }


  validate = (input) => {
    var isValid = true;
    var step1 = '';
    var step2 = [];
    var step3 = [];
    var step4 = [];

    // VALIDATION CHECKS
    // must choose one complaint type
    if (this.state.newComplaint.selectedTypes.length === 0) {
      step1 = 'Please select at least one type of complaint';
      isValid = false;
    }

    // must choose date time or check unknown and write something
    if (this.state.newComplaint.incidentDetails.dateTime === null && this.state.newComplaint.incidentDetails.dateTimeUnknown === false) {
      step3.push("Please either choose a date of incident or select 'Unknown' and specify");
      isValid = false;
    }
    // date must be in from 1753 to 9999
    const year = this.state.newComplaint.incidentDetails.dateTime != null ? this.state.newComplaint.incidentDetails.dateTime.getFullYear() : null;
    if (year != null && (year < 1753 || year > 9999)) {
      step3.push("You may only choose a date from the year 1753 to 9999");
      isValid = false;
    }
    // 'Do you have any evidence' must have a value
    if(this.state.newComplaint.incidentDetails.evidence === '') {
      step3.push("Please choose Yes or No for 'Do you have any evidence of the incident(s)?'");
      isValid = false;
    }

  // 'Do you know who was in charge' must have a value
    if(this.state.newComplaint.incidentDetails.inCharge === '') {
      step3.push("Please choose Yes or No for 'Do you know who was in charge of the establishment at that time?'");
      isValid = false;
    }
    
  // 'Were the police contacted' must have a value
  if(this.state.newComplaint.incidentDetails.policeContact === '') {
      step3.push("Please choose Yes/No/Unknown for 'Were the police contacted?'");
      isValid = false;
    }

    // if "other" is selected "nature of incident" can't be blank
    if (this.state.newComplaint.selectedTypes.indexOf('Other') > -1) {
      const trimmedNature = this.state.newComplaint.incidentDetails.natureIncident.trim();
      if(trimmedNature.length < 1){
        step3.push("Please describe the nature of the incident");
        isValid = false;
      }
    }

    // city can't be blank
    const trimmedCity = this.state.newComplaint.location.city.trim();
    if (trimmedCity.length < 1) {
      step2.push("Please enter the name of a city");
      isValid = false;
    }

    // county can't be blank
    const trimmedCounty = this.state.newComplaint.location.county.trim();
    if (trimmedCounty.length < 1) {
      step2.push("Please enter the name of a county");
      isValid = false;
    }

    const onlyEmail = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    const reResult = onlyEmail.test(this.state.newComplaint.complainant.email.trim());
    if (this.state.newComplaint.complainant.email.length > 0 && reResult === false) {
      step4.push("email format is invalid");
      isValid = false;
    }

    this.setState({
      validation: {
        step1: step1,
        step2: step2,
        step3: step3,
        step4: step4,
      }
    });
    return isValid;
  }

  clearForm() {
    if (recaptchaEnabled && this.recaptchaInstance && this.recaptchaInstance.reset) {
      this.recaptchaInstance.reset()
    }
    this.setState({
      ...this.state,
      isVerified: false,
      submitButtonDisabled: false,
      captchaError: '',
      hidethanks: true,
      newComplaint: {
        googleResponse: '',
        selectedTypes: [],
        complaintTypes: [],
        source: 'Web',
        location: {
          serialnumber: '',
          displayname: '',
          premisesname: '',
          legalname: '',
          dba: '',
          address: '',
          city: '',
          zip: '',
          county: '',
          zone: '1',
          licensepermitid: ''
        },
        incidentDetails: {
          dateTime: null,
          dateTimeUnknown: false,
          dateTimeUnknownSpecify: '', //this is kinda in the Complaint Questions document but I thought its ridiculous :)
          evidence: '',
          evidenceSpecify: '',
          discover: '',
          inCharge: '',
          photoFile: null,
          photoName: '',
          inChargeSpecify: '',
          natureIncident: '',
          policeContact: '',
          policeContactSpecify: '',
          whereOccur: '',
          duration: '',
          involvedPerson: '',
          involvedPersonSpecify: '',
          noiseSource: '',
          additionalDetails: ''
        },
        complainant: {
          name: '',
          email: '',
          phone: ''
        }

      },
      validation: {
        step1: '',
        step2: [],
        step3: [],
        step4: []
      }
    });
  }
  render() {
    const captchaStyle = {
      alignItems: 'center'
    };
    if (this.state.hidethanks) {
      return (

        <div className="container">
          <form
            onSubmit={this.handleFormSubmit}
            onReset={this.clearForm}
            id="parentForm"
          >
            <div className="form-group row">
              <ComplaintType
                complaintTypeObj={this.state.newComplaint.selectedTypes}
                complaintTypeSelected={this.handleComplaintTypes}
                passSelectedTypes={this.handleSelectedTypes}
                validationMsg={this.state.validation.step1}
              />
            </div>
            <div className="form-group row">
              <Location
                locationObj={this.state.newComplaint.location}
                suggestions={this.state.locationData}
                locationChanges={this.handleLocationChanges}
                validationMsgLoc={this.state.validation.step2}
              />
            </div>
            <div className="form-group row">
              <ComplaintDetails
                incidentObj={this.state.newComplaint.incidentDetails}
                showTypeSelected={this.state.newComplaint.selectedTypes}
                incidentChanges={this.handleIncidentDetailsChanges}
                validationMsgCD={this.state.validation.step3}
                photoUpload={this.handlePhotoUpload}
              />
            </div>
            <div className="form-group row">
              <Complainant
                complainantChanges={this.handleComplainantChanges}
                complainantObj={this.state.newComplaint.complainant}
                emailValidationMsg={this.state.validation.step4}
              />
            </div>
            {this.state.captchaError && (
              <div className="centralize spacer">
                <span className="text-danger">{this.state.captchaError}</span>
              </div>
            )}
            {recaptchaEnabled && (
              <div className="centralize spacer" style={captchaStyle}>
              <ReCAPTCHA
                ref={(el) => { this.recaptchaInstance = el }}
                sitekey={recaptchaSiteKey}
                className="centralize"
                asyncScriptOnLoad={this.recaptchaLoaded}
                onChange={this.userVerified}
                onExpired={this.userVerificationExpired}
              />
              </div>
            )}
            <div className="centralize spacer">
              <button className="btn btn-sla-secondary" onClick={this.clearForm}>Clear Form</button>
              <button className="btn btn-sla-primary" type="Submit" disabled={this.state.submitButtonDisabled}>Submit Form</button>
            </div>
          </form>
        </div>
      );
    } 
    else {
      return (<ThankYou submitSuccess={this.state.submitSuccess} filenew={this.fileNew}/>)
    }
  }
}




// WEBPACK FOOTER //
// ./src/components/Home.js